import { AppliancesFilters } from '@hakimo-ui/hakimo/types';
import {
  defaultFilters,
  isApplianceType,
  isNeedsAttentionReason,
  PAGE_SIZE,
} from './util';

export type ViewMode = 'grid' | 'list';

export interface AppliancesUrlState {
  search: string;
  filters: AppliancesFilters;
  page: number;
  viewMode: ViewMode;
}

export const defaultUrlState: AppliancesUrlState = {
  search: '',
  filters: defaultFilters,
  page: 1,
  viewMode: 'grid',
};

function appendArray(params: URLSearchParams, key: string, values: string[]) {
  values.forEach((value) => params.append(key, value));
}

export function getSearchParams(
  search: string,
  filters: AppliancesFilters,
  page: number
): string {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('pageSize', String(PAGE_SIZE));
  if (search) params.append('search', search);
  appendArray(params, 'applianceType[]', filters.applianceType);
  appendArray(params, 'tenantId[]', filters.tenantId);
  appendArray(params, 'needsAttention[]', filters.needsAttention);
  return params.toString();
}

export function tenantAppliancesParams(tenantId: string): string {
  const params = new URLSearchParams();
  params.append('tenantId[]', tenantId);
  return params.toString();
}

export function serializeUrlState(state: AppliancesUrlState): URLSearchParams {
  const { search, filters, page, viewMode } = state;
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  appendArray(params, 'applianceType', filters.applianceType);
  appendArray(params, 'tenantId', filters.tenantId);
  appendArray(params, 'needsAttention', filters.needsAttention);
  if (page > 1) params.set('page', String(page));
  if (viewMode !== 'grid') params.set('viewMode', viewMode);
  return params;
}

export function parseUrlState(
  params: URLSearchParams
): Partial<AppliancesUrlState> {
  const state: Partial<AppliancesUrlState> = {};

  const search = params.get('search');
  if (search) state.search = search;

  const filters: AppliancesFilters = {
    applianceType: params.getAll('applianceType').filter(isApplianceType),
    tenantId: params.getAll('tenantId'),
    needsAttention: params
      .getAll('needsAttention')
      .filter(isNeedsAttentionReason),
  };
  if (
    filters.applianceType.length > 0 ||
    filters.tenantId.length > 0 ||
    filters.needsAttention.length > 0
  ) {
    state.filters = filters;
  }

  const page = Number(params.get('page'));
  if (Number.isInteger(page) && page > 0) state.page = page;

  if (params.get('viewMode') === 'list') state.viewMode = 'list';

  return state;
}
